import React from "react";

interface HotelFilterProps {
  hotels: any[];
  starRatings: number[];
  priceRange: [number, number];
  onFilterChange: (filters: {
    starRatings: number[];
    priceRange: [number, number];
  }) => void;
}

const HotelFilter = ({
  hotels,
  starRatings,
  priceRange,
  onFilterChange,
}: HotelFilterProps) => {

  const toggleStar = (rating: number) => {
    const updated = starRatings.includes(rating)
      ? starRatings.filter((r) => r !== rating)
      : [...starRatings, rating];

    onFilterChange({
      starRatings: updated,
      priceRange,
    });
  };

  const maxPrice =
    hotels && hotels.length > 0
      ? Math.max(...hotels.map((h) => h.Price || 0))
      : 100000;

  const handlePriceChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newMax = parseInt(e.target.value) || maxPrice;

    onFilterChange({
      starRatings,
      priceRange: [0, newMax],
    });
  };

  const renderStars = (count: number) => "★".repeat(count);

  const starOptions = [5, 4, 3, 2, 1];

  return (
    <div className="card mb-4">
      <div className="card-header bg-light">
        <h6 className="mb-0">Filters</h6>
      </div>

      <div className="card-body">

        {/* Star Rating */}
        <div className="mb-3">
          <h6 className="fs-14 fw-semibold">Star Rating</h6>

          {starOptions.map((star) => (
            <div className="form-check" key={star}>
              <input
                type="checkbox"
                className="form-check-input"
                checked={starRatings.includes(star)}
                onChange={() => toggleStar(star)}
              />

              <label className="form-check-label">
                <span className="text-warning">{renderStars(star)}</span>
                <span className="ms-2">{star}-star</span>
              </label>
            </div>
          ))}
        </div>

        {/* Price Filter */}
        <div>
          <h6 className="fs-14 fw-semibold">Price Range (INR)</h6>

          <input
            type="range"
            className="form-range"
            min={0}
            max={maxPrice}
            step={1000}
            value={priceRange[1]}
            onChange={handlePriceChange}
          />

          <p className="fs-13 text-muted">
            Up to ₹{priceRange[1].toLocaleString()}
          </p>
        </div>

      </div>
    </div>
  );
};

export default HotelFilter;